import { Box, IconButton, Typography } from "@mui/material"
import { EvidencesTypeValueEnum } from "../../../utils/enums/evidences"
import { icons } from "../../../utils/icons"
import { useTranslation } from "react-i18next"
import { useStyles } from "../styles"
import { UploadEvidenceTitleProps } from "../types"
import { useMemo } from "react"

export const UploadEvidenceTitle = ({ name, customeTitle, minAmount = 0, maxCount = 0, size, value, expanded, canSeeFiles, seeFiles, handleExpanded }: UploadEvidenceTitleProps) => {
    const { t } = useTranslation()
    const styles = useStyles()
    const list = useMemo(() => Object.values(value ?? {}), [value])

    return (
        <Box sx={styles.flex} mr={1}>
            <Typography sx={styles.containerTitle}>
                {customeTitle ?? t(`general.evidences.${name}`)}
                {!!(minAmount > 0) ? <span> *</span> : ''}
            </Typography>

            <Box sx={styles.containerSee}>
                <Box sx={styles.amountContainer}>
                    <Typography sx={styles.amount}>{![EvidencesTypeValueEnum.SIGN.toString(), EvidencesTypeValueEnum.COMMENT.toString(), EvidencesTypeValueEnum.OBSERVATION_COMMENT.toString()].includes(name) ? `Max: ${size} mb` : ''}</Typography>

                    <Typography sx={styles.amount}>
                        {list?.length} / {maxCount}
                    </Typography>
                </Box>

                {[EvidencesTypeValueEnum.SIGN.toString(), EvidencesTypeValueEnum.COMMENT.toString(), EvidencesTypeValueEnum.OBSERVATION_COMMENT.toString()].includes(name) && Object.values(value ?? {})?.length > 0 && (
                    <IconButton
                        onClick={(e) => {
                            if (!!expanded) {
                                e.stopPropagation()
                            }
                            if (!!expanded && !!canSeeFiles) {
                                handleExpanded(name, false)
                            }
                            seeFiles({ name, value: true })
                        }}
                        sx={styles.see}
                    >
                        {icons('visibility')}
                    </IconButton>
                )}
            </Box>
        </Box>
    )
}